<app-form-field
  [label]="label"
  [required]="required"
  [optional]="optional"
  [control]="control"
  [submitted]="submitted"
  [errorMessages]="errorMessages"
  [serverError]="serverError"
  actionVerb="Select"
>
  <ng-select
    [ngClass]="selectClass"
    [class.is-invalid]="isInvalid"
    [style.background-color]="readonly ? '#e9ecef' : null"
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [multiple]="multiple"
    [searchable]="searchable"
    [closeOnSelect]="closeOnSelect"
    [readonly]="readonly"
    [formControl]="formControl"
    [id]="id"
    [placeholder]="placeholder"
    (change)="change.emit($event)"
    (focus)="focus.emit($event)"
    (focusout)="focusout.emit($event)"
    (keypress)="keypress.emit($event)"
  >
    <ng-content></ng-content>
  </ng-select>
</app-form-field>
